import React from "react";

import { interludio } from "../../../utils/copy";
import fotoAmuleto from "../../../assets/images/ConversasTerapeuticas/amuleto.jpeg";

/* O pingente-amuleto da turma fundadora. Copy do doc de ajustes jul/2026. */
export function Amuleto() {
  return (
    <section id="amuleto" data-bg="#2c171e" className="poster-section amulet-section dark-sec">
      {/* data-motion="media" vai no slot, não na figure: o atributo carrega o
          tratamento global de foto (fundo concreto, flash e grão) e na figure
          inteira ele pintava a coluna toda de concreto */}
      <figure className="amulet-figure">
        <span className="amulet-paper">
          <span data-motion="media" className="amulet-slot">
            <img src={fotoAmuleto} alt="Pingente-amuleto da turma fundadora, usado no colo" className="h-full w-full object-cover object-center" />
          </span>
        </span>
        <figcaption className="sr-only">Fotografia do pingente-amuleto da turma fundadora.</figcaption>
      </figure>

      <div className="amulet-copy">
        <p className="amulet-kicker">{interludio.kicker}</p>
        <h2 data-motion="title" className="type-display amulet-title">{interludio.titulo}</h2>
        <p data-motion="lead" className="amulet-lead">{interludio.lead}</p>
        <blockquote className="type-voice amulet-quote">
          <p>{interludio.citacao}</p>
        </blockquote>
        <footer className="amulet-sign">
          <strong>{interludio.assinatura}</strong>
          <span>{interludio.cargo}</span>
        </footer>
        <div data-motion="gesture" aria-hidden="true" className="amulet-rule" />
      </div>
    </section>
  );
}
